export interface Persona {
  id: string;
  label: string;
  description: string;
  icon: string;
  color: string;
  appRoles: { appKey: string; role: 'ADMIN' | 'GESTIONNAIRE' | 'UTILISATEUR' }[];
  allSites: boolean;
}

export const PERSONAS: Persona[] = [
  {
    id: 'admin-ti',
    label: 'Admin TI',
    description: 'Accès complet à toutes les apps',
    icon: 'ShieldCheck',
    color: '#f3e8ff',
    appRoles: [
      { appKey: 'inventaire', role: 'ADMIN' },
      { appKey: 'admin', role: 'ADMIN' },
      { appKey: 'hub', role: 'ADMIN' },
      { appKey: 'shophub', role: 'ADMIN' },
      { appKey: 'flotte', role: 'ADMIN' },
      { appKey: 'analytics', role: 'ADMIN' },
    ],
    allSites: true,
  },
  {
    id: 'responsable-regional',
    label: 'Responsable régional',
    description: 'Inventaire + Hub — sites assignés manuellement',
    icon: 'MapPin',
    color: '#dbeafe',
    appRoles: [
      { appKey: 'inventaire', role: 'GESTIONNAIRE' },
      { appKey: 'hub', role: 'UTILISATEUR' },
    ],
    allSites: false,
  },
  {
    id: 'operateur-terrain',
    label: 'Opérateur terrain',
    description: 'Hub uniquement — accès lecture',
    icon: 'HardHat',
    color: '#f0fdf4',
    appRoles: [{ appKey: 'hub', role: 'UTILISATEUR' }],
    allSites: false,
  },
  {
    id: 'gestionnaire',
    label: 'Gestionnaire',
    description: 'Inventaire lecture + Analytics + Hub',
    icon: 'BarChart3',
    color: '#fff7ed',
    appRoles: [
      { appKey: 'inventaire', role: 'GESTIONNAIRE' },
      { appKey: 'analytics', role: 'UTILISATEUR' },
      { appKey: 'hub', role: 'UTILISATEUR' },
    ],
    allSites: true,
  },
];
